import { CCard, CCardBody, CCol, CContainer, CForm, CFormFeedback, CFormInput, CFormLabel, CInputGroup, CRow } from '@coreui/react'
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Icon from 'components/icon/Icon';
import { CFormInputWithMask } from 'components/input';
import { UnifiedLoader } from 'components/loader';
import { ToastBase } from 'components/toast';
import { CustomButton } from 'components/buttons';
import { LogoContainer } from 'components/logo';
import { logout } from 'features/auth';
import { selectLoading, setLoading } from 'features/loader';
import { fetchLogin, setUser } from 'features/login';
import { resetMenu } from 'features/menu';
import { setVisibleSecondary, setVisible } from 'features/modal';
import { selectDataToast, selectMessageToast, selectTitleToast, selectTypeToast, selectVisibleToast, setVisibleToast } from 'features/toast';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react'
import { shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectRol, selectToken } from 'features/auth';
import { SERVER_ROUTE } from 'utils/constants';
import * as Yup from 'yup';
import './Principal.scss';
import { clearAlumnoDashboard } from 'features/Alumno/dashboardSlice';
import { clearFacilitadorDashboard } from 'features/Facilitador/dashboardSlice';
import { clearAlumnoEvaluacion } from 'features/Alumno/evaluacionSlice';
import { clearFacilitadorEvaluacion } from 'features/Facilitador/evaluacionSlice';
import { clearSesiones } from 'features/Alumno/sesionSlice';
import { clearAlumnoEntrega } from 'features/Alumno/entregaSlice';
import { resetAlumnoCuenta } from 'features/Alumno/cuentaSlice';

function Principal() {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => selectLoading(state));
  const token = useAppSelector((state) => selectToken(state), shallowEqual);
  const idRol = useAppSelector((state) => selectRol(state), shallowEqual);
  
  const [passwordShow, setPasswordShow] = useState(false);
  const visible = useAppSelector((state) => selectVisibleToast(state), shallowEqual);
  const color = useAppSelector((state) => selectTypeToast(state), shallowEqual);
  const title = useAppSelector((state) => selectTitleToast(state), shallowEqual);
  const message = useAppSelector((state) => selectMessageToast(state), shallowEqual);
  const data = useAppSelector((state) => selectDataToast(state), shallowEqual);

  const UsuarioSchema = Yup.object().shape({
    user: Yup.string()
      .min(3, "Mínimo 3 caracteres")
      .required('Campo requerido'),
    password: Yup.string()
      .required('Campo requerido'),
  })

  const formik = useFormik({
    initialValues: { user: '', password: '' },
    validationSchema: UsuarioSchema,
    onSubmit: async (values) => {
      dispatch(setUser({ ...values }))
      dispatch(setLoading(true));
      dispatch(resetMenu());
      await dispatch(fetchLogin({}));
    }
  });

  useEffect(() => {
    if (token && idRol && (idRol === 5 || idRol === 6 || idRol === 7)) {
      navigate(`${SERVER_ROUTE}/dashboard`);
    }
  }, [token, idRol, navigate]);

  useEffect(() => {
    dispatch(clearAlumnoDashboard());
    dispatch(clearAlumnoEvaluacion());
    dispatch(clearSesiones());
    dispatch(clearAlumnoEntrega());
    dispatch(resetAlumnoCuenta());

    dispatch(clearFacilitadorDashboard());
    dispatch(clearFacilitadorEvaluacion());

    dispatch(logout());
    dispatch(setVisibleSecondary(false));
    dispatch(setVisible(false));
    dispatch(resetMenu());
  }, [dispatch]);

  return (
    <>
      <div className="login-page min-vh-100 d-flex align-items-center">
        <CContainer>
          <CRow className="justify-content-center">

            <CCol lg={6} className='d-none d-lg-flex flex-column justify-content-center text-center'>
              <div className="login-brand mb-4">
                <LogoContainer
                  src={require('../../resources/logo_lideres.png')}
                  alt="Líderes en Acción"
                  size="lg"
                  variant="brand"
                  className="mb-4"
                />
                <h1 className="brand-title mb-3">
                  Líderes en Acción
                </h1>
                <h4 className="brand-subtitle mb-4">
                  Programa de Ciudadanía Integral
                </h4>
                <p className="brand-description">
                  Plataforma de formación ciudadana integral para niñas, niños y jóvenes de Guatemala. 
                  Desarrollamos liderazgo y habilidades sociales para construir el futuro del país.
                </p>
              </div>
            </CCol>
            <CCol lg={6} md={8} sm={10}>

              <CCard className='login-card shadow-lg border-0'>
                <CCardBody className='p-4 p-lg-5'>
                  <div className="d-lg-none text-center mb-4">
                    <LogoContainer
                      src={require('../../resources//logo_lideres.png')}
                      alt="Líderes en Acción"
                      size="md"
                      variant="mobile"
                      className="mb-3"
                    />
                    <h4 className="mobile-title fw-bold">Líderes en Acción</h4>
                    <p className="mobile-subtitle">Iniciar Sesión</p>
                  </div>
                  
                  <div className="d-none d-lg-block text-center mb-4">
                    <h3 className="login-title fw-bold mb-2">Bienvenido</h3>
                    <p className="login-subtitle text-muted">Ingresa tus credenciales para acceder a la plataforma</p>
                  </div>
                  <CForm
                    onSubmit={formik.handleSubmit}
                    className='row g-3'
                  >
                    <CRow className='mb-4'>
                      <CCol>
                        <CFormLabel htmlFor='user'>Usuario<span className='text-danger'>*</span></CFormLabel>
                        <CFormInputWithMask
                          placeholder="Ingrese usuario"
                          id='user'
                          readOnly={loading}
                          value={formik.values.user ? formik.values.user : ''}
                          feedbackInvalid={formik.errors.user}
                          invalid={formik.touched.user && Boolean(formik.errors.user)}
                          onChange={formik.handleChange}
                          mask={/^[a-zA-Z0-9_]{1,50}$/}
                        />
                      </CCol>
                    </CRow>
                    <CRow className='mb-4'>
                      <CCol >
                        <CFormLabel htmlFor='password'>Contraseña<span className='text-danger'>*</span></CFormLabel>
                        <CInputGroup className="has-validation">
                          <CFormInput
                            type={passwordShow ? 'text' : 'password'}
                            placeholder={"Ingrese contraseña"}
                            id='password'
                            aria-describedby='claveInputGroup'
                            readOnly={loading}
                            invalid={formik.touched.password && Boolean(formik.errors.password)}
                            onChange={formik.handleChange}
                            maxLength={255}
                          />
                          <CustomButton type="button" variant="outline" color="secondary" onClick={() => setPasswordShow(!passwordShow)} icon={<Icon icono={passwordShow ? 'mdiEyeOffOutline' : 'mdiEyeOutline'} />}></CustomButton>
                          <CFormFeedback invalid className='mt-2' aria-describedby='claveInputGroup'>{formik.errors.password}</CFormFeedback>
                        </CInputGroup>
                      </CCol>
                    </CRow>

                    <CustomButton 
                      type='submit' 
                      variant='primary'
                      size='lg'
                      className='w-100 mb-4'
                      disabled={loading}
                    >
                      {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                    </CustomButton>

                    <div className="text-center">
                      <button 
                        type="button"
                        className="btn-link-custom"
                        onClick={() => navigate('/lideresaccion')}
                      >
                        ← Volver al inicio
                      </button>
                      <div className="mt-3">
                        <span className="text-muted">¿Aún no tienes cuenta?</span>
                        <button
                          type="button"
                          className="btn-link-custom ms-2"
                          onClick={() => navigate(`${SERVER_ROUTE}/registro`)}
                        >
                          Regístrate aquí
                        </button>
                      </div>
                    </div>
                  </CForm>
                  {loading && (
                    <UnifiedLoader variant="minimal" size="md" className="position-absolute top-50 start-50 translate-middle" />
                  )}
                </CCardBody>
              </CCard>

            </CCol>
          </CRow>
        </CContainer>
      </div>
      <ToastBase
        autohide={false}
        visible={visible}
        color={color}
        message={message}
        data={data}
        title={title}
        onClose={() => { dispatch(setVisibleToast(false)); }}
      />
    </>

  )
}

export default Principal
